import React from "react";
import WindowFunc from "../wea-tools/window";
import WeaTools from "../wea-tools";
import middleware from "../../middleware";
import isEmpty from "lodash/isEmpty";

import WeaBrowser from "./Browser";
import { getFd } from "../wea-tools/callApi";
import { renderLevelCmps, renderBrowser } from "./specialBrowser";

import "./style/index";
import classNames from "classnames";
import isEqual from "lodash/isEqual";

function getHrmDatas(datas) {
  let selectedDataB = [];
  if (datas && datas.length > 0) {
    for (let i = 0; i < datas.length; i++) {
      let data = datas[i];
      if (data) {
        data.type = data.type || "resource";
        data.lastname = data.lastname || data.name || "";
        if (data.type === "all") {
          // 所有人
          data.id = data.id || "all_x";
          data.nodeid = "all_x";
          selectedDataB = [data];
          break;
        } else if (data.type === "resource") {
          data.nodeid = `resource_${data.id}x`;
        } else {
          data.nodeid = `${data.type}_${data.id}x`;
        }
        if (
          selectedDataB &&
          !selectedDataB.some(d => d.nodeid == data.nodeid)
        ) {
          selectedDataB.push(data);
        }
      }
    }
  }
  return selectedDataB;
}

function getDataOfProps(props) {
  const { type, isSingle, valueObj, replaceDatas, value, valueSpan } = props;
  let data = [];
  if (valueObj !== undefined || replaceDatas !== undefined) {
    try {
      data = (valueObj || replaceDatas || []).filter(item => item && item.id);
    } catch (e) {
      /* eslint no-console: 0 */
      console && console.warn("浏览按钮脏数据: ", e);
      data = [];
    }
    if (type == 1 || type == 17) {
      data = getHrmDatas(data);
    }
    return data;
  }
  if ("value" in props && isSingle) {
    if (value) {
      if (type == 1 || type == 17) {
        data = [{ id: value, name: valueSpan }];
      } else {
        let name = "";
        if (!isEmpty(replaceDatas) && replaceDatas[0]) {
          name = replaceDatas[0].orgWholePathspan || replaceDatas[0].name;
        }
        data = [{ id: value, name: valueSpan || name }];
      }
    } else {
      data = [];
    }
    return data;
  }
  return undefined;
}

const getHash = () =>
  Math.random()
    .toString(36)
    .substr(2, 6);

class Main extends React.Component {
  static urlOfIframeInDialogCallBack = {};
  constructor(props) {
    super(props);
    this.searchAdFormCallbackKey = getHash();
    this.renderLevelCmps = renderLevelCmps.bind(this);
    this.renderBrowser = renderBrowser.bind(this);
    this.state = {
      browserloaded: false,
      selectOptions: []
    };
    this.urlOfIframeInDialogKey = getHash();
    this.checkUrlOfIframeInDialogCallBackFunction();
  }
  componentDidMount() {
    this.setMinWidth();
    if (this.props.type == "34") {
      this.getLevelCmpsDatas();
    }
    this.checkUrlOfIframeInDialogCallBackFunction();
  }
  componentDidUpdate() {
    this.checkUrlOfIframeInDialogCallBackFunction();
  }
  componentWillReceiveProps(nextProps) {
    this.setMinWidth(nextProps);
    if (
      !isEqual(this.props.dataParams, nextProps.dataParams) &&
      this.props.type == "34"
    ) {
      this.getLevelCmpsDatas(nextProps.dataParams);
    }
  }
  componentWillUnmount() {
    const win = WindowFunc.getTop().ecCom ? WindowFunc.getTop() : window;
    if (
      this.urlOfIframeInDialogKey &&
      win.ecCom &&
      win.ecCom.WeaBrowser &&
      win.ecCom.WeaBrowser.urlOfIframeInDialogCallBack[
        this.urlOfIframeInDialogKey
      ]
    ) {
      win.ecCom.WeaBrowser.urlOfIframeInDialogCallBack[
        this.urlOfIframeInDialogKey
      ] = undefined;
    }
  }
  checkUrlOfIframeInDialogCallBackFunction = () => {
    const { onChange } = this.props;
    const win = WindowFunc.getTop().ecCom ? WindowFunc.getTop() : window;
    if (
      this.urlOfIframeInDialogKey &&
      win.ecCom &&
      win.ecCom.WeaBrowser &&
      !win.ecCom.WeaBrowser.urlOfIframeInDialogCallBack[
        this.urlOfIframeInDialogKey
      ]
    ) {
      win.ecCom.WeaBrowser.urlOfIframeInDialogCallBack[
        this.urlOfIframeInDialogKey
      ] = data => {
        if (Array.isArray(data)) {
          const result = data.filter(item => item && item.id);
          this.set(result);
          if (typeof onChange === "function") {
            onChange(
              `${result.map(r => r.id)}`,
              `${result.map(r => r.name)}`,
              result
            );
          }
        }
        return this;
      };
    }
  };
  focus() {
    this.browser && this.browser.focus && this.browser.focus();
  }
  set(datas) {
    this.browser && this.browser.set && this.browser.set(datas);
  }
  openModal() {
    this.browser && this.browser.openModal && this.browser.openModal();
  }
  closeModal() {
    this.browser && this.browser.closeModal && this.browser.closeModal();
  }
  get() {
    return this.browser && this.browser.get && this.browser.get();
  }
  reload() {
    this.browser && this.browser.reload && this.browser.reload();
  }
  getLevelCmpsDatas(newParams = "") {
    let { dataURL } = this.props;
    const { dataParams, type } = this.props;
    dataURL = dataURL || `/api/public/browser/data/${type}`;
    dataURL = `${dataURL}?${getFd(newParams || dataParams)}`;
    WeaTools.callApi(dataURL)
      .then(data => {
        this.setState({ selectOptions: data.datas });
      })
      .catch(e => this.props.onError && this.props.onError(e));
  }

  setMinWidth(props) {
    props = props || this.props;
    if (props.resize && this.refs.weaBrowser) {
      let dom = $(this.refs.weaBrowser);
      const browserWidth = 210;
      const interval = setInterval(() => {
        let width = dom.parent().outerWidth();
        if (width > 0) {
          if (width < 112) width = 112;
          dom.css("max-width", width);
          // 明细表单特殊处理
          let minWidth = browserWidth;
          if (width < browserWidth) {
            minWidth = width;
          }
          if (this.props.isDetail == 1) minWidth = width;
          dom
            .find(".wea-associative-search")
            .filter(":not(.wea-field-readonly)")
            .css("min-width", minWidth - 32)
            .css("margin-right", 12);
          dom.css("visibility", "visible");
          dom = null;
          clearInterval(interval);
        }
      }, 10);
    }
  }
  render() {
    const specialBrowser = this.renderBrowser();
    const { className, customized, fieldName, viewAttr, style } = this.props;
    const cls = classNames("wea-browser", className, {
      customized,
      "wea-field": /^field/.test(fieldName),
      "wea-field-readonly": viewAttr == "1"
    });
    let content;
    let inputHidden;
    if (specialBrowser) {
      content = specialBrowser;
    } else {
      const { dataURL, type } = this.props;
      const { browserloaded } = this.state;
      if (!browserloaded) {
        const data = getDataOfProps(this.props) || [];
        const ids = data.map(item => item.id || "").join(",");
        inputHidden = (
          <input type="hidden" id={fieldName} name={fieldName} value={ids} />
        );
      }
      content = (
        <WeaBrowser
          initFunc={browser => {
            this.setState({ browserloaded: true });
            this.browser = browser;
          }}
          {...this.props}
          dataURL={dataURL || `/api/public/browser/data/${type}`}
          searchAdFormCallbackKey={this.searchAdFormCallbackKey}
          urlOfIframeInDialogKey={this.urlOfIframeInDialogKey}
          setMinWidth={() => this.setMinWidth(this.props)}
        />
      );
    }
    return [
      <div className={cls} style={style} ref="weaBrowser">
        {content}
      </div>,
      inputHidden
    ];
  }
}

const Com = middleware(Main, "WeaBrowser");

export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-browser-test/index.js